import moment from "moment";
import I18n from "app/i18n";
import { DateTime } from "luxon";

export const notificationSortDate = (val: Date) => {
  if (val) {
    const now = moment();
    const notificationDate = moment(val);

    const diffDays = now.diff(notificationDate, "days");

    if (diffDays < 1) {
      return I18n.t("Today");
    } else if (diffDays < 7) {
      return I18n.t("This Week");
    } else if (diffDays < 30) {
      return I18n.t("This Month");
    } else {
      return I18n.t("Everything Else");
    }
  } else {
    return null;
  }
};

export const notificationDate = (val: Date) => {
  if (val) {
    const now = moment();
    const postDate = moment(val);

    const diffMinutes = now.diff(postDate, "minutes");
    const diffHours = now.diff(postDate, "hours");
    const diffDays = now.diff(postDate, "days");
    const diffWeeks = now.diff(postDate, "weeks");

    if (diffMinutes < 1) {
      return I18n.t("Just now");
    } else if (diffMinutes < 60) {
      return `${diffMinutes} ${I18n.t("m")}`;
    } else if (diffHours < 24) {
      return `${diffHours} ${I18n.t("h")}`;
    } else if (diffDays < 7) {
      return `${diffDays} ${I18n.t("d")}`;
    } else if (diffWeeks < 4) {
      return `${diffWeeks} ${I18n.t("w")}`;
    } else {
      return DateTime.fromJSDate(postDate.toDate()).toLocaleString({ day: "numeric", month: "short" });
    }
  } else {
    return null;
  }
};
